import CollapseButton from "../atoms/CollapseButton";

/**
 * CollapsibleTh - 折りたたみ可能なテーブルヘッダーセル
 *
 * 展開中はラベル + ◁ 折りたたみボタンを横並びで表示する。
 * 折りたたみ中は ▷ 展開ボタンのみを狭い th 内に表示する。
 *
 * @param {string}   label      - 列の表示ラベル
 * @param {boolean}  isExpanded - true のとき展開状態
 * @param {function} onToggle   - 折りたたみ切り替えハンドラ
 */
function CollapsibleTh({ label, isExpanded, onToggle }) {
  return (
    <th
      className={`border border-gray-400 py-2 font-normal bg-gray-50 ${
        isExpanded ? "px-3 whitespace-nowrap" : "px-0 w-6"
      }`}
    >
      {isExpanded ? (
        <div className="flex items-center justify-between gap-2">
          <span>{label}</span>
          <CollapseButton isExpanded={true} onToggle={onToggle} />
        </div>
      ) : (
        <CollapseButton isExpanded={false} onToggle={onToggle} fullWidth />
      )}
    </th>
  );
}

export default CollapsibleTh;
